import { F01_MEMOJI_OLDER_IMAGES } from 'data/images/f01/memoji-older'
import type { VariantImagesDefinition } from 'types/images'

import { WALLPIF01_IMAGES } from './default'

export const WALLPIF01_MEMOJI_OLDER_IMAGES = {
  ...F01_MEMOJI_OLDER_IMAGES,
  experience: {
    background: {
      ...WALLPIF01_IMAGES.experience.background,
      srcSet: [
        '/images/wallpif01/memoji-older/experience.webp',
        '/images/wallpif01/memoji-older/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...WALLPIF01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/wallpif01/memoji-older/experience_pitch.webp',
        '/images/wallpif01/memoji-older/experience_pitch@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    ...WALLPIF01_IMAGES.bigResultsPitch,
    first: {
      ...WALLPIF01_IMAGES.bigResultsPitch.first,
      srcSet: [
        '/images/wallpif01/memoji-older/big-results-pitch/big_results_pitch_01.webp',
        '/images/wallpif01/memoji-older/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      ...WALLPIF01_IMAGES.bigResultsPitch.second,
      srcSet: [
        '/images/wallpif01/memoji-older/big-results-pitch/big_results_pitch_02.webp',
        '/images/wallpif01/memoji-older/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      ...WALLPIF01_IMAGES.bigResultsPitch.third,
      srcSet: [
        '/images/wallpif01/memoji-older/big-results-pitch/big_results_pitch_03.webp',
        '/images/wallpif01/memoji-older/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
  },
  problemAreasPitch: WALLPIF01_IMAGES.problemAreasPitch,
} satisfies VariantImagesDefinition<typeof WALLPIF01_IMAGES>
